export const SystemUserGetSchema = {
    id: 'id',
    pages: {
        general: {
            pageId: 'general',
            firstName: 'firstName',
            lastName: 'lastName',
            title: 'title',
            organization: 'organization',
            email: 'email',
            additionalEmails: 'additionalEmails',
            role: 'role',
            password: 'password',
            comment: 'comment',
            isBypassRadiusAuth: 'isBypassRadiusAuth'
        },
        expiration: {
            pageId: 'expiration',
            hasExpiration: 'hasExpiration',
            subscriptionPeriod: 'subscriptionPeriod',
            subscriptionPeriodUnit: 'subscriptionPeriodUnit',
            subscriptionPeriodUnitValues: {
                hours: 'Hours',
                days: 'Days',
                months: 'Months'
            },
            startMode: 'startMode',
            startModeValues: {
                firstLogin: 'FirstLogin',
                specifiedDate: 'SpecifiedDate'
            },
            startDate: 'startDateAndTime',
            userFirstLogin: 'userFirstLogin'
        },
        contact: {
            pageId: 'contact',
            phone: 'phone',
            mobile: 'mobile',
            fax: 'fax',
            address: 'address',
            country: 'country',
            state: 'state',
            zip: 'zip'
        },
        twoStepAuth: {
            pageId: 'twoStepAuth',
            isTwoFactorAuth: 'isTwoFactorAuth',
            twoFactorAuthQrUrl: 'twoFactorAuthQrUrl'
        },
        status: {
            pageId: 'status',
            statusDataList: 'statusDataList',
            statusDataSchema: {
                uid: 'uid',
                appName: 'appName',
                creationTime: 'creationTime',
                lastUsedTime: 'lastUsedTime',
                remoteAddress: 'remoteAddress'
            },
            createdDate: 'createdDate',
            modifiedDate: 'modifiedDate'
        },
        serviceDomains: {
            pageId: 'serviceDomains',
            serviceDomainList: 'serviceDomainList'
        }
    }
}

export const SystemUserGetListSchema = {
    name: 'name',
    description: 'description',
    firstName: 'firstName',
    lastName: 'lastName',
    company: 'company',
    email: 'email',
    phone: 'phone',
    role: 'role',
    roleDn: 'roleDn',
    status: 'status'
}

export const SystemUserCreateSchema = {
    name: 'name',
    firstName: 'firstName',
    lastName: 'lastName',
    email: 'email',
    role: 'role',
    password: 'password',
    enableTwoStepAuthentication: 'enableTwoStepAuthentication'
}

export const SystemUserStatuses = {
    connected: 'connected',
    disconnected: 'disconnected',
    disabled: 'disabled'
}

export const SystemUserFilterSchema = {
    freeTextSearch: 'freeTextSearch',
    role: 'role',
    creationDate: 'creationDate',
    modificationDate: 'modificationDate'
}